<template>
  <div class="container admin-page-py">
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <div class="page-title">Admin Dashboard</div>
            <div class="page-subtitle">Access and help monitor your team wellness at anywhere you are</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3" v-for="tab of tabs">
            <page-selection-button
                :title="tab.title"
                :subtitle="tab.subtitle"
                :link="tab.link"
            ></page-selection-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabs: [
        {
          title: 'Compliance',
          subtitle: 'View employee compliance',
          link: '/admin/staff-compliance',
        },
        {
          title: 'Team Management',
          subtitle: 'Connect with your team',
          link: '/team-members/all',
        },
        {
          title: 'Company',
          subtitle: 'Edit your company details',
          link: '/company-profile',
        },
        {
          title: 'Remote Readiness',
          subtitle: 'View employee remote readiness',
          link: '/admin/remote-readiness',
        },
        {
          title: 'External Team Finance Report',
          subtitle: 'General overview of freelance and contractors task hours summary. Only visible to admin',
          link: '/admin/finance-report/summary',
        },
      ],
    };
  },
};
</script>
